import { Checkbox, IconButton, TextField, Tooltip } from "@mui/material";
import { Box, useMediaQuery } from "@mui/material";
import { Menu } from "@mui/material";
import { Typography } from "@mui/material";
import { styles } from "../../pages/Tracks/styles";
import { styles as exploreStyles } from "../../pages/ExplorePage/styles";
import { FONT_FAMILY } from "../../theme";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";
import { FilterAndSortButton } from "../TracksPageComponents/styles";
import { filterMenuStyles } from "../TracksPageComponents/styles";
import { SelectField } from "./styles";
import { GenresArray } from "../constants";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { ExploreFilterMenuProps } from "./types";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const ExploreFilterMenu: React.FC<ExploreFilterMenuProps> = ({
  genres,
  handleChangeGenre,
}) => {
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const openFilterMenu = Boolean(filterAnchorEl);

  const handleFilterDropdownClose = () => {
    setFilterAnchorEl(null);
  };

  const handleOpenFilterDropdown = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setFilterAnchorEl(event.currentTarget);
  };

  return (
    <>
      <FilterAndSortButton
        aria-controls={openFilterMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openFilterMenu ? "true" : undefined}
        onClick={handleOpenFilterDropdown}
        sx={styles.filterButton}
      >
        <FilterListIcon sx={{ margin: "10px" }} />
        Filters
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={filterAnchorEl}
        open={openFilterMenu}
        onClose={handleFilterDropdownClose}
        PaperProps={{
          style: filterMenuStyles.menuPaperProps,
        }}
        sx={filterMenuStyles.menu}
      >
        <Box
          sx={{
            ...filterMenuStyles.filterMenuContainer,
            width: isSmallScreen ? "300px" : "auto",
          }}
        >
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", marginTop: -2 }}
          >
            <Tooltip title="Close" placement="top">
              <IconButton onClick={handleFilterDropdownClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ padding: "15px", paddingTop: 0 }}>
            <Typography variant="h5">Filters</Typography>
          </Box>
          <SelectField
            multiple
            sx={{
              ...exploreStyles.selectField,
              ...{
                width: isSmallScreen ? "93%" : "250px",
              },
            }}
            id="checkboxes-tags-demo"
            options={GenresArray}
            disableCloseOnSelect
            fullWidth
            onChange={(e, v) => handleChangeGenre(e, v)}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                <>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={""}
                InputLabelProps={{ shrink: false }}
              />
            )}
          />
        </Box>
      </Menu>
    </>
  );
};
